import React from "react";
import { Box } from "@chakra-ui/react";
import LandingPageCarousel from "../../Pages/LandingPageComponents/LandingPageCarousel";

const CourseComponent = () => {
  return (
    <Box w="full" mt={4}>
      <LandingPageCarousel />
    </Box>
  );
};

export default CourseComponent;
